import { render, staticRenderFns } from "./carrelloCategoriaMobile.vue?vue&type=template&id=59472380&"
import script from "./carrelloCategoriaMobile.vue.ts?vue&type=script&lang=ts&"
export * from "./carrelloCategoriaMobile.vue.ts?vue&type=script&lang=ts&"
import style0 from "./carrelloCategoriaMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports